import { graphql, ResultOf } from "conversion_flows/lib/graphql"

export const GET_CAR_HIGHLIGHTS_FOR_WIDGET = graphql(`
  query CarHighlightsForWidget($carId: ID!) {
    conversionBoxCarHighlights(carId: $carId) {
      insightsBasisText
      highlights {
        name
        text
        title
      }
    }
  }
`)

export type GetCarHighlightsForWidgetResult = ResultOf<
  typeof GET_CAR_HIGHLIGHTS_FOR_WIDGET
>
